import Notification from '../../components/notification/notification';

class CopyButton {

    constructor(element) {
        this.$element = element;

        this.initialize();
    }

    initialize() {
        this.setEvents();
    }

    setEvents() {
        this.$element.addEventListener('click', (e) => {
            this.addToClipboard();
            e.preventDefault();

            this.$element.setAttribute('aria-pressed', 'true');
            this.$element.setAttribute('disabled', 'disabled');
            this.$element.classList.remove('icon-link');
            this.$element.classList.add('icon-check');

            setTimeout(() => {
                this.$element.setAttribute('aria-pressed', 'false');
                this.$element.removeAttribute('disabled');
                this.$element.classList.remove('icon-check');
                this.$element.classList.add('icon-link');
            }, 3000); // make sure this is in sync with notification hide timeout
        });
    }

    addToClipboard() {
        navigator.clipboard.writeText(window.location.href);

        new Notification(translations.notifications.copy_link, {
            autoclose: true
        });
    }
}

export { CopyButton };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-copybutton]');
        $$roots.forEach($root => {
            const $rootAPI = new CopyButton($root);
            $rootAPI.initialize();
        });
    }
});
